"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWidgetStyling = void 0;
var react_1 = __importStar(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UseTextWidgetsOrder_1 = require("Project/QwilrEditor/WidgetRegistry/Utils/UseTextWidgetsOrder");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var FilterableColorProvider_1 = require("Project/QwilrEditor/Styling/FilterableColorProvider");
var widgetStyle_1 = require("@CommonFrontend/Utils/widgetStyle");
var PropertyControls_1 = require("Project/QwilrEditor/RegistryElement/PropertyControls/PropertyControls");
var FontSize_1 = require("Project/QwilrEditor/RegistryElement/PropertyControls/FontSize");
var Utils_1 = require("./Utils");
var FontColourPicker_1 = require("./FontColourPicker");
var BulkTextColourChanger_1 = require("./BulkTextColourChanger");
var ExpandableSection_1 = require("./ExpandableSection");
exports.TextWidgetStyling = (0, mobx_react_1.observer)(function () {
    var textWidgetsOrder = (0, UseTextWidgetsOrder_1.useTextWidgetsOrder)();
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var blockStyleStore = blockStore.blockStyleStore;
    var widgetAndStyleConfigs = (0, react_1.useMemo)(function () {
        return textWidgetsOrder.map(function (textType) {
            var widgetConfig = (0, EditorWidgetRegistry_1.getConfigByType)(textType);
            var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: widgetConfig.type, traitName: "styleable" });
            (0, tiny_invariant_1.default)(!!styleableConfig, "Cannot render block-level style controls for a widget that doesn't have the styleable trait");
            return { styleableConfig: styleableConfig, widgetConfig: widgetConfig };
        });
    }, [textWidgetsOrder]);
    var configsAndStyles = widgetAndStyleConfigs.map(function (_a) {
        var _b;
        var styleableConfig = _a.styleableConfig, widgetConfig = _a.widgetConfig;
        var styleKey = styleableConfig.styleKey, properties = styleableConfig.properties;
        var blockStyle = (_b = blockStyleStore.getElementStyle(styleKey)) !== null && _b !== void 0 ? _b : {};
        var style = (0, widgetStyle_1.widgetStyle)({
            blockStyle: blockStyle,
            colorProvider: colorProvider,
            overrides: {},
            styleableConfig: { styleKey: styleKey, properties: properties },
            paragraphBlockStyle: blockStyleStore.getElementStyle("p"),
            heading2BlockStyle: blockStyleStore.getElementStyle("h2"),
        });
        return { style: style, styleableConfig: styleableConfig, widgetConfig: widgetConfig };
    });
    return (react_1.default.createElement(kaleidoscope_1.Stack, null,
        react_1.default.createElement(BulkTextColourChanger_1.BulkTextColourChanger, { configsAndStyles: configsAndStyles }),
        configsAndStyles.map(function (_a) {
            var widgetConfig = _a.widgetConfig, styleableConfig = _a.styleableConfig, style = _a.style;
            return (react_1.default.createElement(ExpandableSection_1.ExpandableSection, { key: widgetConfig.type, icon: widgetConfig.icon, displayName: widgetConfig.displayName },
                react_1.default.createElement(StyleableControls, { styleKey: styleableConfig.styleKey, properties: styleableConfig.properties, style: style })));
        })));
});
var manuallyPositionedProperties = ["size", "color"];
var StyleableControls = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var styleKey = _a.styleKey, properties = _a.properties, style = _a.style;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var blockStyleStore = blockStore.blockStyleStore;
    var blockStyle = (_b = blockStyleStore.getElementStyle(styleKey)) !== null && _b !== void 0 ? _b : {};
    function onChangeHandler(property, value) {
        var nextStyle = (0, lodash_1.cloneDeep)(blockStyle);
        (0, lodash_1.set)(nextStyle, property.path, value);
        blockStyleStore.setElementStyle(styleKey, nextStyle);
    }
    var fontSize = (0, Utils_1.getPropertyAndValue)("size", "fontSize", style, properties);
    var fontColour = (0, Utils_1.getFontColourPropertyAndValue)(style, properties);
    (0, tiny_invariant_1.default)("abs" in fontColour.value, "`fontColour.value` should have been remarshalled to a `IColorObjectType` by `widgetStyle()`");
    var advancedTextStyles = properties.filter(function (p) { return !manuallyPositionedProperties.includes(p.path); });
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", padding: "s" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s" },
            react_1.default.createElement(FontColourPicker_1.FontColourPicker, { currentColour: fontColour.value, onColorChange: function (newColor) { return onChangeHandler(fontColour.property, newColor); } }),
            react_1.default.createElement(FontSize_1.FontSize, { value: fontSize.value, min: fontSize.property.min, max: fontSize.property.max, onChange: function (newValue) { return onChangeHandler(fontSize.property, newValue); }, onScale: lodash_1.noop })),
        advancedTextStyles.map(function (p) {
            return (react_1.default.createElement(PropertyControls_1.PropertyControls, { key: p.path, target: "blockStyle", property: p, style: style, onChangeHandler: onChangeHandler }));
        })));
});
